import { log } from 'log';
import { useCallback } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { languageService } from 'js/services/language.service';

import * as constants from '../../../constants';

export const useRequestDesktopPacket = ({
    sdk,
    license,
    transactionID,
    userId,
    identifierType,
    reasonRef
}) => {
    const lang = useUserSelector(prop('lang'));
    const twoLetterLang = languageService.getTwoLetterLanguage(lang);

    return useCallback(() => {
        log('gcReq', { transactionID, license });

        sdk.setLicense(license);

        if (window.GeoComply?.Client?.ReasonCode) {
            switch (reasonRef.current) {
                case constants.GEOLOCATION_REASON.FOREGROUND_CHECK:
                    sdk.setReasonCode(window.GeoComply?.Client.ReasonCode.POST_INTERVAL_FOREGROUND);
                    break;
                case constants.GEOLOCATION_REASON.IP_CHANGE_CHECK:
                    sdk.setReasonCode(window.GeoComply?.Client.ReasonCode.IP_CHANGE);
                    break;
                case constants.GEOLOCATION_REASON.INITIAL_CHECK:
                    sdk.setReasonCode(window.GeoComply?.Client.ReasonCode.LOGIN);
                    break;
                case constants.GEOLOCATION_REASON.INTERVAL_CHECK:
                    sdk.setReasonCode(window.GeoComply?.Client.ReasonCode.INTERVAL);
                    break;
                case constants.GEOLOCATION_REASON.RECONNECT_CHECK:
                    sdk.setReasonCode(window.GeoComply?.Client.ReasonCode.POST_INTERVAL_FOREGROUND);
                    break;
                case constants.GEOLOCATION_REASON.ACL_RULE_FAILURE_CHECK:
                    sdk.setReasonCode(window.GeoComply?.Client.ReasonCode.USER_DRIVEN_RETRY);
                    break;
                default:
                    // no op
                    break;
            }
        }

        sdk.setGeolocationReason(reasonRef.current);
        sdk.setUserId(userId);
        sdk.customFields.set('transactionId', transactionID);
        sdk.customFields.set('identifier_type', identifierType);
        sdk.customFields.set('language', twoLetterLang);
        sdk.requestGeolocation();
    }, [
        sdk,
        license,
        twoLetterLang,
        transactionID,
        userId,
        identifierType,
        reasonRef
    ]);
};
